import React from 'react';
import { YIELD_DEFAULT_ROUND } from 'screens/YieldV2/constants';
import FormInputWithPrecisionDisplay from '../../../FormInputWithPrecisionDisplay';

const DamageField = () => {
  return (
    <div className="flex flex-col gap-0.5 weight-input">
      <label
        htmlFor="damage"
        className="text-neutral-60 tracking-tighter text-sm"
      >
        Damage
      </label>
      <FormInputWithPrecisionDisplay
        fieldName="damage"
        inputSuffix="%"
        id="damage"
        round={YIELD_DEFAULT_ROUND}
      />
    </div>
  );
};

export default DamageField;
